import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project, index }) => {
  return (
    <motion.div
      className="rounded-2xl overflow-hidden shadow-md transition-all bg-white hover:-translate-y-3 hover:shadow-xl"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -10 }}
    >
      <div className="relative h-72 overflow-hidden">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover transition-all hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary to-accent flex items-center justify-center opacity-0 hover:opacity-95 transition-all">
          <Link
            to={`/projects`}
            className="py-3 px-6 bg-white text-primary rounded-full font-semibold shadow-lg hover:scale-105 transition-all"
          >
            Voir les détails
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;